jQuery(function ($) {
  const video = document.querySelector(".modal-work-movie__video");
  const modal = document.getElementById("modal-work-movie");

  modal.addEventListener("shown.bs.modal", function () {
    video.play();
  });

  modal.addEventListener("hide.bs.modal", function () {
    video.pause();
  });
});
